<button  mat-mini-fab (click)="toggleShow()" aria-label="Legend widget button" class="widget-button"><mat-icon svgIcon="map_legend"></mat-icon></button>
<ng-container *ngIf="show()">
    <mat-card class="menu-card legend-card" >
        <mat-card-content>
            <button style="float:right" mat-icon-button (click)="toggleShow()">
                <mat-icon >close</mat-icon>
            </button>
            <section>
                <h3>
                    <strong>{{'map.legend' | transloco | uppercase}}</strong>
                </h3>
                <app-legend-widget [view]="mapview"></app-legend-widget>
            </section>
        </mat-card-content>
      </mat-card>
</ng-container>